function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
var dotWrapStyle = {
  position: "absolute",
  bottom: "10px",
  left: "50%",
  transform: "translateX(-50%)"
};
var dotItemStyle = {
  width: "20px",
  height: "20px",
  borderRadius: "50%",
  margin: "0 10px",
  display: "inline-block",
  cursor: "pointer"
};

var Dots = _ref => {
  var {
    length,
    activeIndex,
    setActiveIndex
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: dotWrapStyle
  }, new Array(length).fill("").map((_, i) => /*#__PURE__*/React.createElement("span", {
    onClick: () => setActiveIndex(i),
    key: i,
    style: _extends({}, dotItemStyle, {
      background: i === activeIndex ? "#000" : "#999",
      transform: "scale(" + (i === activeIndex ? 1.3 : 1) + ")"
    })
  })));
};

export default Dots;